/*eslint-disable*/
import $urls from '../urls/url';
import $api from '../axios/index';
import $Cookies from 'js-cookie';
import store from '@/common/store/';
import common from './common'
import { promises } from 'fs';

// 登陆前接口
const HOMEBEFORE ={
  //获取热门游戏以及平台

  newHeatGamePlatform(params){
    return new Promise((resolve, reject) =>{
     $api.post($urls.HOMEBEFORE.newHeatGamePlatform,params,resp=>{
       if (resp.status==200) {
         resolve(resp.data.data)
       } else{
        reject(resp)
       }
     },err=>{reject(err)})
    })
  },

   //获取比赛信息
   getSportInfo(params){
     return new Promise((resolve, reject) =>{
      $api.post($urls.HOMEBEFORE.sportinfo,params,resp=>{
        if (resp.status==200) {
          resolve(resp.data.data)
        } else if(resp.data.code==201){
          resolve([])
        }else{
          resolve([])
        }
      },err=>{reject(err)})
     })
   },
  //  获取排行榜数据
  getrankingList(params){
    return new Promise((resolve, reject) =>{
     $api.get($urls.HOMEBEFORE.getrankingList,params,resp=>{
       if (resp.status==200) {
         resolve(resp.data.data)
       } else{
        reject(resp)
       }
     },err=>{reject(err)})
    })
  },
  // 获取视频
  getGoodVedio(params){
    return new Promise((resolve, reject) =>{
     $api.get($urls.HOMEBEFORE.getGoodVedio,params,resp=>{
       if (resp.status==200) {
         resolve(resp.data.data)
       } else{
        reject(resp)
       }
     },err=>{reject(err)})
    })
  },
   //VIP数据
   getVipInfoLis(){
    return new Promise((resolve, reject) => {
      let params = {};
      $api.get($urls.HOMEBEFORE.getVipInfoLis,params,resp=>{
        if(resp.data.code===200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 获取首页优惠图片
  getIndexOffer(){
    return new Promise((resolve, reject) => {
      let frontType  = 2;
      let pageNo = 1;
      let pageSize = 6;
      let params = {
        frontType: frontType,
        pageNo,
        pageSize
      };
      $api.post($urls.HOMEBEFORE.INDEXOFFER,params,resp=>{
        if (resp.data.code === 200) {
          resolve(resp.data.data.list)
        } else {
          resolve([])
        }
      },err=>{reject(err)})
    })
  },
  // 老虎机图片地址
  serverInfo() {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.serverInfo, {}, (resp) => {
        if(resp.data.code===200){
          let serverInfo = resp.data.data.serverInfo;
          let picLink = serverInfo.ftpDomain;
          store.dispatch('setPicLink',picLink)
          resolve(picLink)
        }else {
          reject(resp.data.msg);
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  // 客服链接
  service() {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.download, {}, (resp) => {
        if(resp.data.code===110||resp.data.code===111||resp.data.code===200){
          // console.log(resp.data.data)
          // let customerUrl = resp.data.data.customerUrl;
          resolve(resp.data.data)
        }else {
          reject(resp.data.msg);
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  // 下载链接
  download() {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.download, {}, (resp) => {
        if(resp.data.code===110||resp.data.code===111||resp.data.code===200){
          let customerUrl = resp.data;
          resolve(customerUrl)
        }else {
          reject(resp.data.msg);
        }
      }, err => {
        reject(err.message);
      })
    })
  },
  // 游戏平台
  // 游戏类型:1 - 老虎机，2-真人，3-体育，4-彩票，5-捕鱼王，6-棋牌，7-3D厅
  gamePlatform(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.gamePlatform, params, (resp) => {
        if (resp.data.code === 200) {
          let gameForm = resp.data.data;
          resolve(gameForm)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg);
        }
      }, (err) => {
        reject(err.message);
      })
    })
  },
  // 热门
  heatGamePlatform(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.heatGamePlatform, params, (resp) => {
        if (resp.data.code === 200) {
          let gameForm = resp.data.data;
          resolve(gameForm)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg);
        }
      }, (err) => {
        reject(err.message);
      })
    })
  },
  // 筛选
  queryAllGameList(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.queryAllGameList, params, (resp) => {
        if (resp.data.code === 200) {
          let gameForm = resp.data.data;
          resolve(gameForm)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg);
        }
      }, (err) => {
        reject(err.message);
      })
    })
  },
  // 筛选
  selectUserCollectionList(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.selectUserCollectionList, params, (resp) => {
        if (resp.data.code === 200) {
          let gameForm = resp.data.data;
          resolve(gameForm)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg);
        }
      }, (err) => {
        reject(err.message);
      })
    })
  },
  // 获取所有游戏平台
  allGameInfo(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.allGameInfo, params, (resp) => {
        if (resp.data.code === 200) {
          let gameForm = resp.data.data;
          resolve(gameForm)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg);
        }
      }, (err) => {
        reject(err.message);
      })
    })
  },
  // 游戏平台图片
  platformPicInfo(params = {}) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.platformPicInfo, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }else if(resp.data.code === 201){
          resolve([])
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err.message);})
    })
  },

  // 获取最热游戏列表
  getGameList() {
    return new Promise((resolve, reject) => {
      let frontType  = 1;
      let pageNo  = 1;
      let pageSize = 8;
      let params = {
        frontType: frontType,
        pageNo : pageNo ,
        pageSize: pageSize,
      };
      $api.post($urls.HOMEBEFORE.GAMELIST,params,resp=>{
        if (resp.data.code === 200) {
          let data = common.joint(store.state.picLink, resp, store.state.mySlot);
          resolve(data)
        } else {
          resolve([])
        }
      },err=>{reject(err)})
    })
  },

  // 游戏页面banner
  getBannerList(id) {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: 2,
        position: id,
      };
      $api.post($urls.HOMEBEFORE.BANNERLIST,params,resp=>{
        if(resp.data.code===200){
          let data = resp.data.data.list;
          let arr =[];
          data.forEach((item)=>{
            let obj = {};
            obj['img'] = item.picLink;
            obj['title'] = item.picContent;
            arr.push(obj)
          });
          resolve(arr)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{})
    })

  },
  // 首页导航
  getFirstNavList() {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType
      };
      $api.post($urls.HOMEBEFORE.FIRSTNAVLIST,params,resp=>{
        if(resp.data.code === 200){
          let data = resp.data.data;
          data.forEach((item,index,arr)=>{
            arr[index]['url'] = common.sortIndexNav(item.type);
          });
          resolve(data)
        } else {
          resolve([])
        }
      },err=>{reject(err)})
    });
  },
  // 获取公告
  pushInfoList() {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType,
      };
      $api.post($urls.HOMEBEFORE.PUSHINFOLIST,params,resp=>{
        if(resp.data.code===200){
          let data = resp.data.data.list;
          resolve(data)
        }else {
          resolve([])
        }
      },err=>{reject(err)})
    })
  },
  // 获取首页导航

  //获取挂件图片
  getHomePendant(code){
    return new Promise((resolve, reject) => {
      let params = {
        imgCode: code,
      };
      $api.post($urls.HOMEBEFORE.fetchimg,params,resp=>{
        if(resp.data.code===200){
          // let data = resp.data.data.list;
          resolve(resp.data.data)
        }else {
          resolve([])
        }
      },err=>{reject(err)})
    })
  },
    //获取图片组
    getImgGroup(code){
      return new Promise((resolve, reject) => {
        let params = {
          imgCode: code,
        };
        $api.post($urls.HOMEBEFORE.fetchimg,params,resp=>{
          if(resp.data.code===200){
            // let data = resp.data.data.list;
            resolve(resp.data.data)
          }else {
            resolve([])
          }
        },err=>{reject(err)})
      })
    },
    // 获取365体育信息
    getCustomizeMatch(code){
      return new Promise((resolve, reject) => {
        let params = {
          imgCode: code,
        };
        $api.post($urls.HOMEBEFORE.getCustomizeMatch,params,resp=>{
          if(resp.data.code===200){
            // let data = resp.data.data.list;
            resolve(resp.data.data)
          }else {
            resolve([])
          }
        },err=>{reject(err)})
      })
    },
    getRegisterList(){
      return new Promise((resolve, reject) => {
        let params = {
        };
        $api.post($urls.HOMEBEFORE.getRegisterList,params,resp=>{
          if(resp.data.code===200){
            // let data = resp.data.data.list;
            resolve(resp.data.data)
          }else {
            resolve([])
          }
        },err=>{reject(err)})
      })
    },

};


// 登陆后接口
const HOMEAFTER ={
   //  判断是否代理注册
   queryAgentBonus(params) {
    return new Promise((resolve, reject) => {
       $api.post($urls.HOMEAFTER.queryAgentBonus, params, resp => {
         if(resp.data.success) {
           resolve(resp.data.data)
         }else {
           reject()
         }
     }, err => {reject()})
     })
 },
   // 365代理所有联系方式
   getFrontConfigList(params){
    // let UUID = $Cookies.get('UUID');
    // params = {
    //   configKey: params.configKey,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEAFTER.getFrontConfigList, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          let result = {
            // lockList: [],
            // lockInfo: {
            //   pageNum: 0,
            //   infoPageSize: 0,
            //   total: 0,
            // }
          }
        }
      }, err => {reject(err)})
    })
  },
 // 最低取款额
 getminLimit(params){
  let UUID = $Cookies.get('UUID') || window.localStorage.getItem('UUID');
  params = {
    UUID: UUID,
  };
  return new Promise((resolve, reject) => {
    $api.post($urls.HOMEAFTER.getminLimit, params, resp => {
      if (resp.data.code === 200) {
        let data = resp.data.data
        resolve(data)
      } else {
        let msg = resp.data.msg ? resp.data.msg :resp.data.message;
        let result = {
          lockList: [],
          lockInfo: {
            pageNum: 0,
            infoPageSize: 0,
            total: 0,
          }
        }
      }
    }, err => {reject(err)})
  })
},
// USDT汇率
getusdtRate(params){
    let UUID = $Cookies.get('UUID') || window.localStorage.getItem('UUID');
    params = {
      UUID: UUID,
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEAFTER.getusdtRate, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },
// 365代理联系方式
getfrontconfig(params){
  // let UUID = $Cookies.get('UUID');
  params = {
    configKey: params.configKey,
  };
  return new Promise((resolve, reject) => {
    $api.post($urls.HOMEAFTER.getfrontconfig, params, resp => {
      if (resp.data.code === 200) {
        let data = resp.data.data
        resolve(data)
      } else {
        let msg = resp.data.msg ? resp.data.msg :resp.data.message;
        let result = {
          lockList: [],
          lockInfo: {
            pageNum: 0,
            infoPageSize: 0,
            total: 0,
          }
        }
      }
    }, err => {reject(err)})
  })
},

  // 登录信息
  logedUserInfo() {
    let browser = common.getBrowserInfo()[0];
    let UUID = $Cookies.get('UUID') || window.localStorage.getItem('UUID');
    let deviceId = $Cookies.get('deviceId');
    if(deviceId===undefined||deviceId===''){
      let timeStr = new Date().getTime().toString();
      let str = Math.random().toString().slice(-6);
      deviceId = timeStr + str;
      $Cookies.set('deviceId', deviceId, { expires: 2000 });
    }

    let params = {
      UUID: UUID,
      browser:  browser,
      deviceId: deviceId,
      // domain: document.domain,
      // ipInfo: ' ',
    };

    $api.post($urls.HOMEAFTER.logedUserInfo, params, (resp) => {
      if (resp.data.code === 200) {
        common.deviceInfo();
        $Cookies.set('UUID', UUID)
      } else {}
    }, err => {})

  },
  // 设备信息
  deviceInfo() {
    let UUID = $Cookies.get('UUID') || window.localStorage.getItem('UUID');
    let deviceId = $Cookies.get('deviceId');

    let info = common.getOsInfo();
    let os = '',osVersion = '';
    info.name&&(os=info.name);
    info.version&&(osVersion=info.version);

    let params = {
      frontType: store.state.frontType,
      UUID: UUID,
      deviceId: deviceId,
      ip: '',
      clientTime: new Date().getTime(),
      isp: '',
      os: os,
      osVersion: osVersion,
      dns: '',
      dnsLocation: '',
      proxy: '',
      country: '',
      province: '',
      city: '',
      zipCode: '',
      timeZone: '',
      cookieEnable: '',
      jsEnable: '',
      flashEnable: '',
      javaEnable: '',
      activexEnable: '',
      webrtcEnable: '',
      vbEnable: '',
      adblockEnable: '',
      latitude: '',
      longitude: '',
      language: navigator.language,
      deviceMemory: '',
      maxTouchPoints: '',
      hardwareConcurrency: '',
      cpu: '',
      colorDepth: '',
      displayWidth: '',
      displayHeight: '',
    };
    $api.post($urls.HOMEAFTER.DEVIVEINFO, params, (resp) => {
      if (resp.data.code === 200) {
      } else {}
    }, err => {})
  },
  // 刷新登录状态
  refreshUserInfo() {
    let params = {
      UUID: store.state.UUID,
    };
    $api.post($urls.HOMEAFTER.refresh,params,resp=>{},err=>{})
  },
  // 查询会员账户锁定金额记录
  queryUserLockAmount(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEAFTER.queryUserLockAmount, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let result = {
            lockList: gameList,
            lockInfo: gameInfo,
          };
          resolve(result)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },
  // 会员自助解锁锁定金额
  selfUnlockAmount(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEAFTER.selfUnlockAmount, params, resp => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  }
};

const USER ={
  // 登出
  loginOut() {
    let UUID = $Cookies.get('UUID') || window.localStorage.getItem('UUID');
    if(UUID){
      return new Promise((resolve, reject) => {
        $api.post($urls.USER.LOGINOUT, {UUID:UUID}, (resp) => {
          if(resp.data.code===200){
            $Cookies.remove('UUID');
            store.dispatch('checkLogin');
            resolve('退出登录')
          }else {
            reject(resp.data.msg);
          }
        }, err => {
          reject(err.message);
        })
      })
    }
  },
  // 用户信息
  getUserInfo() {
    return new Promise((resolve, reject) => {
      let browser = common.getBrowserInfo()[0];//取到完整信息
      let UUID = $Cookies.get('UUID') || window.localStorage.getItem('UUID');
      let deviceId = $Cookies.get('deviceId');
      if(deviceId===undefined||deviceId===''){
        let timeStr = new Date().getTime().toString();
        let str = Math.random().toString().slice(-6);
        deviceId = timeStr + str;
        $Cookies.set('deviceId', deviceId, { expires: 2000 });
      }
      let params = {
        UUID: UUID,
        browser:  browser,
        deviceId: deviceId,
        domain: document.domain,
        ipInfo: '',
      };

      $api.post($urls.USER.FIRSTUSERINFO, params, (resp) => {
        if (resp.data.code === 200) {
          let userInfo = resp.data.data;
          resolve(userInfo)
        } else {
          resp.data.msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(resp.data.msg)
        }
      }, err => {
        reject(err.message);
      })

    })
  },
  // （多彩宝）忘记密码-发送验证码
  sendPhoneCodeNew(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.sendCodeNew, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        }else{
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err)})
    })
  },
  // 忘记密码-发送验证码
  sendPhoneCode(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.sendCode, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        }else{
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err)})
    })
  },
  // 忘记密码-重置密码
  confirm(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.confirm, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        }else{
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err)})
    })
  },
  /**
   * 手机验证码登录
   */
  sendVerifictionCode(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.sendVerifictionCode, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        }else{
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err)})
    })
  },
  myOfferEkList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.myOfferEkList, params, (resp) => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err)})
    })
  },
  searchUserAccount(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.searchUserAccount, params, (resp) => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err)})
    })
  }
};

const SLOT ={
  // 我的收藏
  getMyslot() {
    return new Promise((resolve, reject) => {
      let datas = [];
      let params = {
        frontType: store.state.frontType,
        UUID: store.state.UUID,
        pageNo: -1,
        pageSize: 0,
      };
      $api.post($urls.SLOT.mySlot, params, resp => {
          if ( resp.data.code === 200) {
            let datas ;
            if( resp.data.data === null || resp.data.data === undefined){
              datas = []
            }else {
              datas = resp.data.data.list
            }
            store.commit('SET_SLOT_COLLECTION',datas);
            resolve(datas)
          }else{
            store.commit('SET_SLOT_COLLECTION',datas);
            resolve(datas)
          }
        }, err => {reject(err.message)})
    });
  },
   // 老虎机筛选
   selectGameSlotType(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.selectGameSlotType,params,resp=>{
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.newJoint(store.state.picLink, gameList);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 我的收藏分页
  getMyslotStep(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.SLOT.mySlot, params, resp => {
        if ( resp.data.code === 200) {
          let info = resp.data.data;
          let mySlot = common.collectJoint(store.state.picLink,info.list);
          let data = {
            list: mySlot,
            gameInfo: info
          };

          resolve(data)
        }else{
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    });
  },
  // 根据平台code 获取游戏
  getSlotGameByPlatform(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HOMEBEFORE.GETSLOTGAMEPLATFORM, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          let data = common.oldJoint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: data,
            gameInfo: gameInfo,
          }
          resolve(result)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },
  // 压码排行
  getSlotRank() {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType,
        pageNo: 1,
        pageSize: 8,
      };
      $api.post($urls.SLOT.slotRank, params, resp => {
        if (resp.data.code === 200) {
          let data= common.joint(store.state.picLink, resp, store.state.mySlot);
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },
  // 可能喜欢
  getMaybeLike() {
    return new Promise((resolve, reject) => {
      let params = {
        frontType: store.state.frontType,
        UUID: store.state.UUID,
        pageNo: 1,
        pageSize: 4,
      };
      $api.post($urls.SLOT.maybeLike, params, resp => {
        if (resp.data.code === 200) {
          let data = common.oldJoint(store.state.picLink, resp.data.data, store.state.mySlot);
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },
};

const WALLET ={
  // 账户刷新
  refresh() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      };
      $api.post($urls.WALLET.refreshGameAccount,params,(resp)=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 提现申请
  withdrawList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.WALLET.withdrawList, params, (resp) => {
        let data = resp.data.data;
        if(resp.data.code===200){
          resolve(data)
        }else if(resp.data.code!==200){
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    });
  },
  // 投注记录
  gameHistory(params) {
    return new Promise((resolve, reject) => {
        $api.post($urls.WALLET.gameHistory, params, (resp) => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else {
            let msg = resp.data.msg ? resp.data.msg :resp.data.message;
            reject(msg)
          }
        }, err => {reject(err);})
    });
  },
  // 投注记录
  newgameHistory(params) {
    return new Promise((resolve, reject) => {
        $api.post($urls.WALLET.newgameHistory, params, (resp) => {
          if (resp.data.code === 200) {
            let data = resp.data.data;
            resolve(data);
          } else {
            let msg = resp.data.msg ? resp.data.msg :resp.data.message;
            reject(msg)
          }
        }, err => {reject(err);})
    });
  },
  //我的优惠记录列表
  betFlowLockList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.WALLET.betFlowLockList, params, (resp) => {
        let data = resp.data.data;
        if(resp.data.code===200){
          resolve(data)
        }else if(resp.data.code!==200){
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    });
  },
};

const VIP ={
  // 获取账单信息
  myBalanceList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.myBalanceList, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data.list;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 获取账单信息
  myOrderList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.myOrderList, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data.list;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 账单详情
  getBalanceDetail(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.balanceDetail, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })

    })
  },
  // 站内信
  getMsgSiteList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.getMsgSiteList,params,resp=>{
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{})
    })
  },
  // 删除站内信
  deleteMsgSite(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.deleteMsgSite,params,resp=>{
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{})
    })
  },
  // 发送站内信
  insertMsgSite(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.insertMsgSite,params,resp=>{
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{})
    })
  },
  // 阅读站内信
  updateMsgSite(id) {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
        msgId: id,
      };
      $api.post($urls.VIP.updateMsgSite,params,resp=>{
        if (resp.data.code === 200) {
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 邀请列表
  inviteList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.inviteList,params,resp=>{
        if(resp.data.code===200){
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err);})

    })
  },
  // 领取邀请红利
  getInviteBonus(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.VIP.getInviteBonus, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    })
  },
  // 邀请码
  inviteCode() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      };
      $api.post($urls.VIP.inviteCode,params,resp=>{
        if(resp.data.code===200){
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err);})

    })
  }
};

const PAY ={
  // 获取印度银行卡列表
  autoBanks(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.autoBanks, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 获取印度银行卡列表
  inBanks(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.inBanks, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 印度USDT存款
  inPayUSDTOrder(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.inPayUSDTOrder, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 印度提交提款订单
  inPayOrder(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.inPayOrder, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 印度提交提款订单
  offlineAutopayOrder(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.offlineAuto, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 半自动印度提交提款订单
  semiAutomaticPayOrder(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.semiAutomatic, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  //上传图片
  uploadFile(file) {
    return new Promise((resolve, reject) => {
      console.log(file)
      let params = {
        UUID: store.state.UUID,
        file,
      };
      $api.post($urls.PAY.uploadFile, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 获取银行卡列表
  bankCardList() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      };
      $api.post($urls.PAY.bankCardList, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 添加银行卡
  addBank(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.addBankCard,params,resp=>{
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err.message)})
    })
  },
  // 验证银行卡信息
  checkBankCard(item) {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
        cardNumber: item.bankNumber
      };
      $api.post($urls.PAY.checkBankCard, params, resp => {
        if (resp.data.code === 200) {
          item['picUrl'] = resp.data.data.picUrl;
          resolve(item)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})

    })
  },
  // 提款申请
  applyWithdraw(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.applyWithdraw, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})

    })
  },
  // 支付类型
  getPayType(UUID){
     return new Promise((resolve, reject) => {
       let params = {
         UUID: UUID,
         deviceType:'mobile'
       };
       $api.post($urls.PAY.payType,params,resp=>{
         if(resp.data.code===200){
           let data =resp.data.data;
           resolve(data)
         }else {
           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
           reject(msg)
         }
       },err=>{reject(err)})
     })
  },
  // 新支付类型
  getNewPayType(UUID){
    return new Promise((resolve, reject) => {
      let params = {
        UUID: UUID,
        deviceType:'mobile'
      };
      $api.post($urls.PAY.newPayType,params,resp=>{
        if(resp.data.code===200){
          let data =resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 六合彩支付
  getLhcPayType(UUID){
    return new Promise((resolve, reject) => {
      let params = {
        UUID: UUID,
        deviceType:'pc'
      };
      $api.post($urls.PAY.newPayType,params,resp=>{
        if(resp.data.code===200){
          let data =resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 印度存款订单列表
  getindepositOrderlist(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.indepositOrderlist, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          resolve([])
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 取消订单
  incancelOrder(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.incancelOrder, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 获取支付的内容
  getPayConfig(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.payConfig, params, (resp) => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        }else if(resp.data.code === 202){
          resolve(resp.data.code)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})

    })
  },
  // 印度存款内容提交
  submitDepositInfo(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.indiaDeposit, params, (resp) => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})

    })
  },
  // 获取所有平台
  getAllPlatform() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      };
      $api.post($urls.PAY.getAllPlatform, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },
  // 取出全部的金额，用于提现等页面
  withdrawGames() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      };
      $api.post($urls.PAY.withdrawGames, params, (resp) => {
        if (resp.data.code === 200) {
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },
  myOfferEkCount(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.myOfferEkCount, params, (resp) => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})

    })
  },
  // 获取USDT类型
  getUSDTType(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.getUSDTType, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          let err = resp.data.msg
          reject(err)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 获取银行卡列表
  usdtList() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      };
      $api.post($urls.PAY.usdtList, params, resp => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          if(data===null){data=[]}
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    });
  },
  // 添加 USDT 地址
  addUSDTAddress(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.addUSDTAddress,params,resp=>{
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err.message)})
    })
  },
};

const HELP ={
  // 文章类型
  getArticleType(params={}) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HELP.articleType,params, resp=>{
        if(resp.data.code===200) {
          let navList = resp.data.data;
          resolve(navList)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err)})
    })
  },

  // 根据类型获取文章
  getArticleListByType(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.HELP.articleListByType, params, resp => {
        if(resp.data.code===200){
          let data = resp.data.data;
          resolve(data);
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {reject(err.message)})
    });
  },
  // 根据文章ID获取文章内容
  articleById(id) {
    return new Promise((resolve, reject) => {
      let params = {
        articleId: id,
      }
      $api.post($urls.HELP.articleById,params,resp=>{
        if(resp.data.code===200){
          let data = resp.data.data;
          resolve(data);
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err.message)})
    })
  }
};

const CONFIRM ={
  // 绑定生日
  submitBirthDay(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.submitBirthDay,params,resp=>{
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 实名认证
  confirmRealName(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmRealName,params,resp=>{
        if (resp.data.code === 200) {
          resolve(resp.data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 提款密码验证码
  sendWithdrawYZM() {
    return new Promise((resolve, reject) => {
      let params = {
        UUID: store.state.UUID,
      }
      $api.post($urls.PAY.sendWithdrawYZM,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 修改提款密码
  updateWithdrawPW(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.PAY.updateWithdrawPW,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // qq认证
  confirmQQ(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmQQ,params,resp=>{
        if (resp.data.code === 200) {
          resolve(resp.data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // wechat
  confirmWeChat(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmWeChat,params,resp=>{
        if (resp.data.code === 200) {
          resolve(resp.data)
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 修改登录密码
  updateLoginPassword(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.USER.updateLoginPassword,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)});
    })
  },
  // 修改手机号验证码
  sendPhone(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.sendPhone,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // (多彩宝)修改手机号验证码
  sendPhoneColor(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.sendPhoneSMS,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 手机号认证
  confirmPhone(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmPhone,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)});
    })
  },
  // 邮箱发送邮件
  email(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.email,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)});
    })
  },
  // 邮箱认证
  confirmEmail(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.confirmEmail,params,resp=>{
        if(resp.data.code===200){
          resolve('success')
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // build09新邮箱认证
  submitEmail(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.submitEmail,params,resp=>{
        if(resp.data.code===200){
          resolve(resp)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  },
  // 获取电话验证国家列表
  queryCountryList(params={}) {
    return new Promise((resolve, reject) => {
      $api.post($urls.CONFIRM.queryCountryList,params,resp=>{
        if(resp.data.success){
          resolve(resp.data.data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      },err=>{reject(err)})
    })
  }
};
//  queryLotteryResultList  queryLatestOnlineNumber query48HourOnlineNumberList 为火石接口,跑105前在config切换环境
const GAME ={
   //获取开奖记录
   queryLotteryResultList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.queryLotteryResultList, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err.message)})

    })
  },
  //最新steam在线人数信息
  queryLatestOnlineNumber(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.queryLatestOnlineNumber, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err.message)})

    })
  },
  //48小时在线
  query48HourOnlineNumberList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.query48HourOnlineNumberList, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err.message)})

    })
  },
  // 获取今日流水
  topFlowData(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.topFlowData, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data.list;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err.message)})

    })
  },
  // 老虎机搜索
  searchResult(name) {
    return new Promise((resolve, reject) => {
      let params = {
        keyword: name,
        pageSize: 200
      };
      $api.post($urls.GAME.searchResult, params, (resp) => {
        if (resp.data.code === 200) {
          let data = common.oldJoint(store.state.picLink, resp.data.data, store.state.mySlot);
          resolve(data)
        } else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          // console.log(msg)
          reject(msg)
        }
      }, (err) => {reject(err)})
    })
  },
   // 平台全部游戏
   allGame(platformCode,gameType,keyword,pageNo,pageSize) {
    let params = {
      platformCode,
      gameType,
      keyword,
      pageNo,
      pageSize,
    };
    return new Promise((resolve, reject) => {
      $api.post($urls.GAME.allGame, params, resp => {
        if (resp.data.code === 200) {
          let gameList = resp.data.data.list;
          let gameInfo = resp.data.data;
          // console.log(gameList,gameInfo)
          // let data = common.joint(store.state.picLink, gameList, store.state.mySlot);
          let result = {
            gameList: gameList,
            gameInfo: gameInfo,
          }

          resolve(result)
        } else {
          resolve({
            gameList: [],
            gameInfo: {
              pageNum: 0,
              pageSize: 0,
              total: 0
            },
          })
        }
      }, err => {reject(err)})
    })
  },
};

const DISCOUNTS = {
  // 获取优惠列表
  offerList( params = {} ) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.OFFERLIST, params, (resp) => {
        if (resp.data.code === 200) {
          let data = resp.data.data;
          resolve(data)
        } else if (resp.data.code !== 200) {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err.message)})
    })
  },
  // 获取我的优惠列表
  myOffer(params = {}){
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.MYOFFER, params, (resp) => {
        if (resp.data.code === 200) {
          resolve(resp.data.data)
        } else if (resp.data.code !== 200) {
          let obj = {


            list:[],
            total: 0,
          };
          resolve(obj)
        }
      }, (err) => {reject(err.message)})

    })
  },
  // 优惠详情
  offerDetail(params) {
   return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.offerDetail, params, (resp) => {
        if(resp.data.code===200){
          let data = resp.data.data;
          resolve(data)
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err.message)})

    })
  },
  // 获取优惠类型
  queryBonusArticleTypeList( params = {}) {
    return new Promise((resolve, reject) => {
       $api.post($urls.DISCOUNTS.queryBonusArticleTypeList, params, (resp) => {
         if(resp.data.code===200){
           let data = resp.data.data;
           resolve(data)
         }else {
           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
           reject(msg)
         }
       }, (err) => {reject(err.message)})

     })
   },
   //获取优惠列表（新）
   queryBonusArticleInfoList(params) {
    return new Promise((resolve, reject) => {
       $api.post($urls.DISCOUNTS.queryBonusArticleInfoList, params, (resp) => {
         if(resp.data.code===200){
           let data = resp.data.data;
           resolve(data)
         }else {
           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
           reject(msg)
         }
       }, (err) => {reject(err.message)})

     })
   },
    //活动大厅列表
    querySelfApplyBonusList(params) {
      return new Promise((resolve, reject) => {
         $api.post($urls.DISCOUNTS.querySelfApplyBonusList, params, (resp) => {
           if(resp.data.code===200){
             let data = resp.data.data;
             resolve(data)
           }else {
             let msg = resp.data.msg ? resp.data.msg :resp.data.message;
             reject(msg)
           }
         }, (err) => {reject(err.message)})

       })
     },
      //活动大厅获取文章
  queryBonusArticleInfoDetail(params) {
    return new Promise((resolve, reject) => {
       $api.post($urls.DISCOUNTS.queryBonusArticleInfoDetail, params, (resp) => {
         if(resp.data.code===200){
           let data = resp.data.data;
           resolve(data)
         }else {
           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
           reject(msg)
         }
       }, (err) => {reject(err.message)})

     })
   },

}

const DEPOSIT ={
  // ============余额宝==========================
  // 查询可购买的余额宝列表
  checkAvailableYEBListHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.availableYEBList, params, (resp) => {
        resolve(resp)
      }, (err) => { reject(err.message) })
    })
  },
  // 查询已购买的余额宝列表
  checkPurchasedYEBListHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.purchasedYEBList, params, (resp) => {
        resolve(resp)
      }, (err) => { reject(err.message) })
    })
  },
  // 购买余额宝
  buyYEBProgramHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.buyYEBProgram, params, (resp) => {
        resolve(resp)
      }, (err) => { reject(err.message) })
    })
  },
  // 赎回余额宝
  ransomYEBProgramHandler(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.ransomYEBProgram, params, (resp) => {
        resolve(resp)
      }, (err) => { reject(err.message) })
    })
  },
  // VIP页面领取接口  1晋升礼金2生日礼金3节日礼金
  getVipRewardGift(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.getVipRewardGift, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    })
  },
  // VIP快速晋级申请
  fastApplyPromotion(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.fastApplyPromotion, params, resp => {
        if (resp.data.code === 200) {
          resolve('success')
        } else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          reject(msg)
        }
      }, err => {
        reject(err);
      })
    })
  },
  // 申请存款红利
  applyBonus(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.applyBonus, params, (resp) => {
        if(resp.data.code===200 || resp.data.code===808){
          resolve(resp)
        }else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err.message)})

    })
  },
  // 申请VIP红利
  vipapplyBonus(params) {
    // let params = {
    //   platformKey: this.platformKey,
    //   viewOfferId: this.viewOfferId,
    //   applyAmount: this.applyAmount,
    //   betOrderNo: this.betOrderNo
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.vipapplyBonus, params, (resp) => {
        resolve(resp)
      }, (err) => {reject(err.message)})
    })
  },
  //申请时时流水红利
  getRealTimeAmount(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.getRealTimeAmount, params, (resp) => {
        if(resp.data.code===200 || resp.data.code===808){
          resolve(resp)
        }else {
          let msg = resp.data.msg ? resp.data.msg : resp.data.message;
          reject(msg)
        }
      }, (err) => {reject(err.message)})

    })
  },
  //查询会员绑定优惠
  getBindUserInfoList(params) {
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.queryBonusBindUserInfoList, params, (resp) => {
        if(resp.data.code===200){
          resolve(resp)
        }else{
          resolve(resp)
        }
      }, (err) => {reject(err.message)})

    })
  },
  raffle(para) {
    let params = Object.assign({}, { activityType: 1 }, para)
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.raffle, params, (resp) => {
        resolve(resp.data)
      }, (err) => {
        reject(err.message)
      })
    })
  },
  queryNewWin(para = {}) {
    let params = Object.assign({}, { activityType: 1 }, para)
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.queryNewWin, params, (resp) => {
        resolve(resp.data)
      }, (err) => {
        reject(err.message)
      })
    })
  },
  // 大转盘抽奖 未登录
  queryTurntableRaffle(para = {}) {
    let params = Object.assign({}, { activityType: 1 }, para)
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.queryTurntableRaffle, params, (resp) => {
        resolve(resp.data)
      }, (err) => {
        reject(err.message)
      })
    })
  },
// 历史中奖数据
  queryHistoryWin(params) {
    // let params = {
    //   activityType: 1,
    //   pageNo,
    //   pageSize,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.queryHistoryWin, params, (resp) => {
        let data = resp.data.data;
        if(data===null) {
          let obj={
            list: [],
            pageInfo: {
              pageNum: 0,
              pageSize: 0,
              total: 0
            }
          };
          resolve(obj)
        }

        let list = data.list;
        let obj={
          list: list,
          pageInfo: data
        };
        resolve(obj)
      }, (err) => {
        reject(err.message)
      })
    })
  },
  //查询升级优惠
  selectUserUpgradeInfo(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.selectUserUpgradeInfo, params, (resp) => {
        if(resp.data.code===200){
          resolve(resp)
        }else{
          resolve(resp)
        }
      }, (err) => {reject(err.message)})

    })
  },
  // 福利领取
  receiveMyBonus(params){
    return new Promise((resolve, reject) => {
      $api.post($urls.DEPOSIT.receiveMyBonus, params, (resp) => {
        resolve(resp)
      }, (err) => {reject(err.message)})
    })
  },
  // 获取所有可领取的时时流水金额
  realTimeAmountAll(params) {
    // let params = {
    //   activityType: 1,
    //   pageNo,
    //   pageSize,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.realTimeAmountAll, params, (resp) => {
        if(resp.data.code===200){
          let data = resp.data.data
          resolve(data)
        }else{
          let data = resp.data.msg
          reject(data)
        }
      }, (err) => {
        reject(err.message)
      })
    })
  },
  // 领取所有可领取的时时流水金额
  getRealTimeAmountAll(params) {
    // let params = {
    //   activityType: 1,
    //   pageNo,
    //   pageSize,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.getRealTimeAmountAll, params, (resp) => {
        if(resp.data.code===200){
          let data = resp.data.msg
          resolve(data)
        }else{
          let data = resp.data.msg
          reject(data)
        }
      }, (err) => {
        reject(err.message)
      })
    })
  },
  // 获取流水优惠记录
  realTimeRecord(params) {
    // let params = {
    //   activityType: 1,
    //   pageNo,
    //   pageSize,
    // };
    return new Promise((resolve, reject) => {
      $api.post($urls.DISCOUNTS.realTimeRecord, params, (resp) => {
        if(resp.data.code===200){
          let data = resp.data.data
          resolve(data)
        }else{
          let data = resp.data.msg
          reject(data)
        }
      }, (err) => {
        reject(err.message)
      })
    })
  },
};

const SIGN = {
  //信息初始化接口
  //签到可以获得奖励列表 参数pageNo,pageSize
  checkIntegralConfigList(params){
    return new Promise((resolve, reject) =>{
      $api.post($urls.SIGN.checkIntegralConfigList, params, (resp) => {
        if(resp.data.code===200){
          resolve(resp)
        }else{
          resolve(resp)
        }
      }, (err) => {reject(err.message)})
    })
  },
  //兑换可以获得奖励列表
  bonusExchangeConfigList(params){
    return new Promise((resolve, reject) =>{
      $api.post($urls.SIGN.bonusExchangeConfigList, params, (resp) => {
        if(resp.data.code===200){
          resolve(resp)
        }else{
          resolve(resp)
        }
      }, (err) => {reject(err.message)})
    })
  },
  getUserIntegral(params){
    return new Promise((resolve, reject) =>{
      $api.post($urls.SIGN.getUserIntegral, params, (resp) => {
        if(resp.data.code===200){
          resolve(resp)
        }else{
          resolve(resp)
        }
      }, (err) => {reject(err.message)})
    })
  },
  getUserCheckInfo(){
    let params = {}
    return new Promise((resolve, reject) =>{
      $api.post($urls.SIGN.getUserCheckInfo, params, (resp) => {
        if(resp.data.code===200){
          resolve(resp)
        }else{
          resolve(resp)
        }
      }, (err) => {reject(err.message)})
    })
  },


}


// 时时乐
// const TIMELE = {
//   // 获取所有游戏
//   getallGameList(params){
//     return new Promise((resolve, reject) => {
//       $api.post($urls.TIMELE.allGame, params, resp => {
//         if (resp.data.code === 200) {
//           let data = resp.data.data
//           resolve(data)
//         } else {
//           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
//           let result = {

//           }
//         }
//       }, err => {reject(err)})
//     })
//   },
//   // 获取时时乐所有信息
//   getallInfoList(params){
//     // let UUID = $Cookies.get('UUID');
//     // params = {
//     //   configKey: params.configKey,
//     // };
//     return new Promise((resolve, reject) => {
//       $api.post($urls.TIMELE.allInfo, params, resp => {
//         if (resp.data.code === 200) {
//           let data = resp.data.data
//           resolve(data)
//         } else {
//           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
//           let result = {
//             // lockList: [],
//             // lockInfo: {
//             //   pageNum: 0,
//             //   infoPageSize: 0,
//             //   total: 0,
//             // }
//           }
//         }
//       }, err => {reject(err)})
//     })
//   },
//   // 时时乐多条记录下注
//   getbettingList(params){
//     // let UUID = $Cookies.get('UUID');
//     // params = {
//     //   jsonListVo: params.jsonListVo,
//     // };
//     return new Promise((resolve, reject) => {
//       $api.post($urls.TIMELE.bettingList, params, resp => {
//         if (resp.data.code === 200) {
//           let data = resp.data.data
//           resolve(data)
//         } else {
//           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
//           let result = {

//           }
//         }
//       }, err => {reject(err)})
//     })
//   },
//   // 时时乐单条记录下注
//   getbettingVo(params){
//     // let UUID = $Cookies.get('UUID');
//     // params = {
//     //   jsonListVo: params.jsonListVo,
//     // };
//     return new Promise((resolve, reject) => {
//       $api.post($urls.TIMELE.bettingVo, params, resp => {
//         if (resp.data.code === 200) {
//           let data = resp.data.data
//           resolve(data)
//         } else {
//           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
//           let result = {

//           }
//         }
//       }, err => {reject(err)})
//     })
//   },
//   // 根据portId获取该游戏的英雄和属性
//   getHeroList(params){
//     // let UUID = $Cookies.get('UUID');
//     // params = {
//     //   jsonListVo: params.jsonListVo,
//     // };
//     return new Promise((resolve, reject) => {
//       $api.post($urls.TIMELE.getHero, params, resp => {
//         if (resp.data.code === 200) {
//           let data = resp.data.data
//           resolve(data)
//         } else {
//           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
//           let result = {

//           }
//         }
//       }, err => {reject(err)})
//     })
//   },
//   // 获取时时乐注单记录
//   getList(params){
//     // let UUID = $Cookies.get('UUID');
//     // params = {
//     //   jsonListVo: params.jsonListVo,
//     // };
//     return new Promise((resolve, reject) => {
//       $api.post($urls.TIMELE.getList, params, resp => {
//         if (resp.data.code === 200) {
//           let data = resp.data.data
//           resolve(data)
//         } else {
//           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
//           let result = {

//           }
//         }
//       }, err => {reject(err)})
//     })
//   },
//   // 根据portId获取时时乐实时信息
//   getRealTimeLe(params){
//     // let UUID = $Cookies.get('UUID');
//     // params = {
//     //   jsonListVo: params.jsonListVo,
//     // };
//     return new Promise((resolve, reject) => {
//       $api.post($urls.TIMELE.getRealTimeLe, params, resp => {
//         if (resp.data.code === 200) {
//           let data = resp.data.data
//           resolve(data)
//         } else {
//           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
//           let result = {

//           }
//         }
//       }, err => {reject(err)})
//     })
//   },
//   // 获取开奖记录,只能获取1天以内的
//   getResult(params){
//     // let UUID = $Cookies.get('UUID');
//     // params = {
//     //   jsonListVo: params.jsonListVo,
//     // };
//     return new Promise((resolve, reject) => {
//       $api.post($urls.TIMELE.getResult, params, resp => {
//         if (resp.data.code === 200) {
//           let data = resp.data.data
//           resolve(data)
//         } else {
//           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
//           let result = {

//           }
//         }
//       }, err => {reject(err)})
//     })
//   },
//   // 根据portId获取该游戏的投注玩法
//   getSportPlay(params){
//     // let UUID = $Cookies.get('UUID');
//     // params = {
//     //   jsonListVo: params.jsonListVo,
//     // };
//     return new Promise((resolve, reject) => {
//       $api.post($urls.TIMELE.getSportPlay, params, resp => {
//         if (resp.data.code === 200) {
//           let data = resp.data.data
//           resolve(data)
//         } else {
//           let msg = resp.data.msg ? resp.data.msg :resp.data.message;
//           let result = {

//           }
//         }
//       }, err => {reject(err)})
//     })
//   },
// }
//获取用户当前积分信息

const commonApi= {
  HOMEBEFORE,
  HOMEAFTER,
  DISCOUNTS,
  USER,
  SLOT,
  WALLET,
  VIP,
  PAY,
  HELP,
  CONFIRM,
  GAME,
  DEPOSIT,
  SIGN,
  // TIMELE
};
export default commonApi



// WEBPACK FOOTER //
// ./src/common/utils/commonApi.js